import { toArray } from 'lodash';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import { VehicleModel, buildSubmodelsPath, buildMakeYearSubmodelsPath } from 'client/data/models/vehicle';
import { sortByName } from 'site-modules/shared/utils/sorting';
import { filterPubStates } from 'site-modules/shared/utils/publication-states';
import { Select } from 'site-modules/shared/components/select/select';
import { StyledSelect } from 'site-modules/shared/components/styled-select/styled-select';
import { DEFAULT_CLASSNAMES } from './constants';

export const stateToPropsConfig = {
  options: bindToPath(
    props => {
      const { make, model, year, showLatestYears, isMakeYearSubmodels } = props;
      let path = '';

      if (isMakeYearSubmodels) {
        return make && year && buildMakeYearSubmodelsPath({ make: make.slug, year });
      }

      if (make && model && year) {
        path = buildSubmodelsPath({ make: make.slug, model: model.slug, year });
      } else if (make) {
        path = showLatestYears ? `makes["${make.slug}"].latestSubmodels` : `makes["${make.slug}"].submodels`;
      }

      return path;
    },
    VehicleModel,
    (submodelData, props) => filterPubStates(toArray(submodelData), props.pubStates).sort(sortByName)
  ),
};

export const StyledSubmodelDropdown = connectToModel(StyledSelect, stateToPropsConfig);

export const SubmodelDropdown = connectToModel(Select, stateToPropsConfig);

const DEFAULT_PROPS = {
  name: 'select-model',
  toggle: 'Select Model',
  valueKey: 'name',
  labelKey: 'name',
};

StyledSubmodelDropdown.defaultProps = DEFAULT_PROPS;

SubmodelDropdown.defaultProps = {
  ...DEFAULT_PROPS,
  className: `js-submodels-select ${DEFAULT_CLASSNAMES}`,
};
